<template>
    <b-overlay :show="busy" rounded="sm">

        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable">
                <b-card class="w-100pct">

                    <b-card-body class="py-0 px-0">

                        <b-tabs class="gridtabs" v-model="tabindex">
                            <b-tab>
                                <template #title>
                                    <div class="badgecontainer pr-2 mr-1">
                                        <i class="fa fa-repeat text-primary mr-1"></i>
                                        Amend
                                        <b-badge id="selection" variant="primary" class="edit_tab">
                                            {{ selection.length }}</b-badge>
                                        <b-tooltip target="selection" placement="bottom">{{ selection.length }}
                                            ticket(s)
                                            selected</b-tooltip>
                                    </div>

                                </template>

                                <p class="mt-2">

                                    <b-row class="my-2">
                                        <b-col cols="12" sm="6" md="4">
                                            <b-form-group label-cols="12" label="Change Date" label-size="sm">
                                                <!-- <b-input-group>
                                                    <v-date-picker v-model="date_at" mode="date" is24hr color="green"
                                                        :locale="'en-gb'" class="form-control form-control-sm">
                                                        <template v-slot="{ inputValue, inputEvents }">
                                                            <input class="
                                                                    h-19px
                                                                    border-none
                                                                    focus:outline-none focus:border-primary
                                                                    text-primary
                                                                    " :value="inputValue" v-on="inputEvents" />
                                                        </template>
                                                    </v-date-picker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" squared variant="outline-secondary"
                                                            :disabled="!date_at" @click="date_at = null">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group> -->

                                                <b-input-group>
                                                    <daterangepicker style="width:auto !important" size="sm"
                                                        ref="date_at" v-model="date_at" :opens="'right'"
                                                        :locale-data="locale_data" :ranges="false" :showDropdowns="true"
                                                        :linkedCalendars="true" :single-date-picker="'true'">
                                                    </daterangepicker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" @click="date_at = {
        startDate: null,
        endDate: null,
    }
        ">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="8">
                                            <b-form-group label-cols="12" label="Change Reason?" label-for="reasontype">
                                                <!-- <b-form-radio-group class="mt-1 z-0" v-model="reasontype"
                                                    :options="options_reasontype" :aria-describedby="ariaDescribedby"
                                                    name="options_reasontype">
                                                </b-form-radio-group>
                                             -->
                                                <b-form-checkbox-group class="mt-1" v-model="reasontype"
                                                    :options="options_reasontype" :aria-describedby="ariaDescribedby"
                                                    name="options_reasontype"
                                                    @change="reasontype_change"></b-form-checkbox-group>
                                            </b-form-group>
                                        </b-col>


                                    </b-row>



                                    <b-row class="mt-2">
                                        <b-col cols="12" sm="4">
                                            <b-form-group label-cols="12" label="Ticket(s) selected" label-size="sm"
                                                class="mb-0">

                                                <b-input-group>
                                                    <b-form-tags input-id="ticketno" v-model="ticketno"
                                                        tag-variant="primary" separator=" ,;" placeholder="" size="sm"
                                                        class="h-29" add-button-text="+" add-on-change remove-on-delete
                                                        add-button-variant="outline-primary"
                                                        :disabled="true"></b-form-tags>

                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="ticketno = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>



                                        </b-col>
                                    </b-row>

                                </p>

                            </b-tab>

                            <b-tab v-if="reasontype.includes('void')">
                                <template #title>
                                    <i class="fa fa-check-square-o text-primary mr-1"></i>
                                    Void</template>
                                <p class="pt-3 px-0 mb-0">

                                    <b-row>
                                        <b-col>
                                            <b-alert :show="true" variant="primary">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        Charter Tickets listed below that are not invoiced can be Voided
                                                        or
                                                        Unvoided.</b-col></b-row>
                                            </b-alert></b-col>
                                    </b-row>

                                <div class="px-0">
                                    <d-table classdivtable="availtable datatable nested" refid="voids"
                                        :icon="voids.icon" :toolbarlibrary="voids.toolbarlibrary" :tools="voids.tools"
                                        :badges="voids.badges" :fields="voids.fields" :items="voids.items"
                                        :busy="voids.busy" :page="voids.page" :showpages="false" @load="voids_load"
                                        @click="voids_click" @select="voids_select" :showrowcount="false">
                                    </d-table>
                                </div>

                                <b-row>
                                    <b-col cols="12" sm="6">
                                        <b-form-group label="Void Options" label-for="selected_option" label-cols="12">
                                            <b-form-radio-group class="mt-1" v-model="void_type" :options="options_void"
                                                name="options_void"></b-form-radio-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </p>
                            </b-tab>

                            <b-tab v-if="reasontype.includes('client')">
                                <template #title>
                                    <i class="fa fa-check-square-o text-primary mr-1"></i>
                                    Client</template>
                                <p class="pt-3 px-0">
                                    <b-row class="mb-3"><b-col>
                                            All tickets in the selection will be updated with the following Your Ref/PO,
                                            SL
                                            A/C, Event and BL A/C if you save the change.
                                        </b-col>

                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Your Ref / PO" label-for="yourref" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="yourref"
                                                        placeholder="Your Ref / PO" size="sm"
                                                        :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="false"
                                                            variant="outline-secondary" @click="yourref = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                                                <treeselect placeholder="Select slac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="slac"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Event" label-size="sm">
                                                <treeselect placeholder="Select event..." v-model="eventcode"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadEvent"
                                                    searchPromptText="Type at least 4 chars..."
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                                                <treeselect placeholder="Select blac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="blac"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadBLAC"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
<b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="InvoiceNo" label-for="invoiceno" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="invoiceno"
                                                        placeholder="InvoiceNo" size="sm"
                                                        :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="false"
                                                            variant="outline-secondary" @click="invoiceno = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>


                                </p>
                            </b-tab>

                            <b-tab v-if="reasontype.includes('namechange')">
                                <template #title>
                                    <i class="fa fa-check-square-o text-primary mr-1"></i>
                                    Name Change</template>
                                <p class="pt-3 px-0">
                                    <b-row class="mb-3"><b-col>
                                            All tickets in the selection will be updated with the following name if you
                                            save
                                            the change.
                                        </b-col>

                                    </b-row>
                                    <b-row>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Last Name" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="surname" :debounce="debounce"
                                                        placeholder="Last Name"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="surname = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="First Name" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="firstname" :debounce="debounce"
                                                        placeholder="First Name"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="firstname = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Title" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="title" :debounce="debounce"
                                                        placeholder="Title"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="title = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Passenger" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="passenger" :debounce="debounce"
                                                        placeholder="Passenger" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" :disabled="true"
                                                            @click="passenger = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                    </b-row>


                                </p>
                            </b-tab>

                            <b-tab v-if="reasontype.includes('notes')">
                                <template #title>
                                    <i class="fa fa-check-square-o text-primary mr-1"></i>
                                    Notes</template>
                                <p class="pt-3 px-0">
                                    <b-row class="mb-3"><b-col>
                                            All tickets in the selection will be updated with the following notes if you
                                            save
                                            the change.
                                        </b-col>

                                    </b-row>
                                    <b-row class="mt-2">
                                        <b-col cols="12">
                                            <b-form-group label="Notes" label-for="notes" label-cols="12">
                                                <b-input-group class="treeselect_all pr-2px">
                                                    <span style="padding-top: 0.3em; padding-left:32px"
                                                        id="notes-tooltip">
                                                        <i class="fa fa-info-circle text-black"></i></span>
                                                    <b-tooltip target="notes-tooltip" triggers="hover"
                                                        placement="bottom">Please
                                                        let us know below
                                                        the reason if you are delaying the invoicing e.g. waiting for
                                                        PO,
                                                        waiting for
                                                        next statement etc.
                                                    </b-tooltip>

                                                </b-input-group>
                                                <b-form-textarea id="notes" v-model="notes"
                                                    placeholder="Reason for not invoicing?" rows="10" max-rows="10"
                                                    class="smalltextarea courier"></b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-1">
                                        <b-col>
                                            <b-button squared size="sm" variant="outline-primary" class="mr-1"
                                                @click="timestamp">
                                                <i class="fa fa-comment-o"></i>
                                                Add Notes
                                            </b-button>
                                        </b-col>
                                    </b-row>


                                </p>
                            </b-tab>




                        </b-tabs>

                    </b-card-body>
                    <b-card-footer class="nopadding mt-2">
                        <b-row no-gutters>
                            <b-col cols="auto" class="text-left">
                                <b-button squared size="sm" variant="primary" @click="saveit()"
                                    v-if="tabindex != 0 && user.permissions.includes('tickets.save')">
                                    <i class="fa fa-check"></i>
                                    Save It
                                </b-button>
                            </b-col>
                            <b-col class="text-left ml-2 mt-1">
                                <div v-if="busy">
                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                </div>
                                <div v-else>
                                    <span v-html="message"></span>
                                </div>
                            </b-col>

                            <b-col class="text-right" cols="8">
                                <b-button squared size="sm" variant="secondary" @click="discard">
                                    <i class="fa fa-chevron-left pr-1"></i>
                                    Back
                                </b-button>
                            </b-col>
                        </b-row>

                    </b-card-footer>
                </b-card>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "TicketsAmend",
    async mounted() {
        await this.accessdenied();
        // this.ticketschange_load();
    },
    data() {
        return {
            busy: false,
            tabindex: 0,
            debounce: 500,
            readonly: false,
            bllines_readonly: true,
            // resetuninvoiced:false,
            ticketno: [],
            // date_at: this.$moment().format("YYYY-MM-DD"),
            date_at: {
                startDate: this.$moment().format("YYYY-MM-DD"),
                endDate: this.$moment().format("YYYY-MM-DD"),
            },
            yourref: null,
            slac: null,
            blac: null,
            eventcode: null,
            invoiceno: null,
            surname: null,
            firstname: null,
            title: null,
            passenger: null,
            notes: null,
            void_type: "void",
            options_void: [
                { text: 'All Void', value: 'void' },
                { text: 'All Charter', value: 'charter', },
                { text: 'Toggle', value: 'toggle', },
            ],


            unvoidable: false,
            type: null,
            options_type: [
                { id: "void", label: "Void", disabled: false },
                { id: "charter", label: "Charter", disabled: false },
            ],
            reason: null,
            reasontype: [],
            options_reasontype: [
                { text: 'Void', value: 'void', },
                { text: 'Client', value: 'client' },
                { text: 'Name Change', value: 'namechange', },
                { text: 'Notes', value: 'notes', },
            ],
            voids: {
                title: "Voids",
                icon: "fa fa-square text-dark",
                debounce: 500,
                busy: false,
                page: 1,
                denied: [],
                toolbarlibrary: [],
                tools:
                    "go,export",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-center w-50px",
                    },
                    {
                        key: "dateissued",
                        label: "Issued",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = value.split(" ")[0];
                            }
                            return result;
                        },
                    },
                    {
                        key: "type",
                        label: "Type",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "locator",
                        label: "Locator",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "carrier_id",
                        label: "Al",
                        sortable: true,
                        class: "d-none d-xl-table-cell text-center",
                    },

                    {
                        key: "ticketno",
                        label: "Ticket No",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "passenger",
                        label: "Name",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 20) {
                                    result = result.slice(0, 17) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "datetravel",
                        label: "Date Travel",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = value.split(" ")[0];
                            }
                            return result;
                        },
                    },
                    {
                        key: "routing",
                        label: "Routing",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 12) {
                                    result = result.slice(0, 12) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "flightno",
                        label: "FlightNo",
                        sortable: true,
                        class: "d-none d-lg-table-cell text-center",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 14) {
                                    result = result.slice(0, 14) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "class",
                        label: "Class",
                        sortable: true,
                        class: "d-none d-lg-table-cell text-center",
                    },
                    {
                        key: "fare",
                        label: "Fare",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "tax",
                        label: "Tax",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "agent",
                        label: "Agent",
                        sortable: true,
                    },
                    {
                        key: "invoiceno",
                        label: "Invoice No",
                        sortable: true,
                        class: "text-center",
                    },
                ],
                badges: [
                    {
                        key: "carrier_id",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "ticketno",
                        type: "pill",
                        class: "orange",
                    },
                    {
                        key: "class",
                        type: "pill",
                        class: "purple",
                        title: "classname",
                    },
                    {
                        key: "locator",
                        type: "pill",
                        class: "secondary",
                    },
                    {
                        key: "lines",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "type",
                        type: "badge",
                        Charter: "teal",
                        Ticket: "primary",
                        Reissue: "primary",
                        Void: "white",
                        Refund: "white",
                        EMD: "purple",
                    },
                    {
                        key: "fare_type",
                        type: "badge",
                        Unknown: "white",
                        Negotiated: "warning",
                        Net: "purple",
                        Manual: "secondary",
                        Published: "white",
                        Private: "pink",
                        other: "secondary",
                        formatter: (value, key, item) => {
                            switch (parseInt(value)) {
                                case "Unknown":
                                    return "Unknown";
                                    break;
                                case "Negotiated":
                                    return "Negotiated";
                                    break;
                                case "Net":
                                    return "Net";
                                    break;
                                case "Manual":
                                    return "Manual";
                                    break;
                                case "Published":
                                    return "Published";
                                    break;
                                case "Private":
                                    return "Private";
                                    break;
                                default:
                                    return value;
                            }
                        },
                    },
                    {
                        key: "queued",
                        type: "badge",
                        Yes: "danger",
                        No: "info",
                        formatter: (value, key, item) => {
                            if (value == true) {
                                return "Yes";
                            } else if (value == false) {
                                return "No";
                            } else {
                                return "";
                            }
                        },
                    },
                ],
                items: [],
                selected: [],
            },
            zhold: {
                title: "Zhold",
                icon: "fa fa-ticket text-orange",
                debounce: 500,
                busy: false,
                page: 1,
                denied: [],
                toolbarlibrary: [],
                tools:
                    "go,export",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-center w-50px",
                    },
                    {
                        key: "dateissued",
                        label: "Issued",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "type",
                        label: "Type",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "locator",
                        label: "Locator",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "carrier_id",
                        label: "Al",
                        sortable: true,
                        class: "d-none d-xl-table-cell text-center",
                    },

                    {
                        key: "ticketno",
                        label: "Ticket No",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "passenger",
                        label: "Name",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 20) {
                                    result = result.slice(0, 17) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "datetravel",
                        label: "Date Travel",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = value.split(" ")[0];
                            }
                            return result;
                        },
                    },
                    {
                        key: "routing",
                        label: "Routing",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 12) {
                                    result = result.slice(0, 12) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "flightno",
                        label: "FlightNo",
                        sortable: true,
                        class: "d-none d-lg-table-cell text-center",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 14) {
                                    result = result.slice(0, 14) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "class",
                        label: "Class",
                        sortable: true,
                        class: "d-none d-lg-table-cell text-center",
                    },
                    {
                        key: "fare",
                        label: "Fare",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "tax",
                        label: "Tax",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "agent",
                        label: "Agent",
                        sortable: true,
                    },
                    {
                        key: "invoiceno",
                        label: "Invoice No",
                        sortable: true,
                        class: "text-center",
                    },
                ],
                badges: [
                    {
                        key: "carrier_id",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "ticketno",
                        type: "pill",
                        class: "orange",
                    },
                    {
                        key: "class",
                        type: "pill",
                        class: "purple",
                        title: "classname",
                    },
                    {
                        key: "locator",
                        type: "pill",
                        class: "secondary",
                    },
                    {
                        key: "lines",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "type",
                        type: "badge",
                        Charter: "teal",
                        Ticket: "primary",
                        Reissue: "primary",
                        Void: "white",
                        Refund: "white",
                        EMD: "purple",
                    },
                    {
                        key: "fare_type",
                        type: "badge",
                        Unknown: "white",
                        Negotiated: "warning",
                        Net: "purple",
                        Manual: "secondary",
                        Published: "white",
                        Private: "pink",
                        other: "secondary",
                        formatter: (value, key, item) => {
                            switch (parseInt(value)) {
                                case "Unknown":
                                    return "Unknown";
                                    break;
                                case "Negotiated":
                                    return "Negotiated";
                                    break;
                                case "Net":
                                    return "Net";
                                    break;
                                case "Manual":
                                    return "Manual";
                                    break;
                                case "Published":
                                    return "Published";
                                    break;
                                case "Private":
                                    return "Private";
                                    break;
                                default:
                                    return value;
                            }
                        },
                    },
                    {
                        key: "queued",
                        type: "badge",
                        Yes: "danger",
                        No: "info",
                        formatter: (value, key, item) => {
                            if (value == true) {
                                return "Yes";
                            } else if (value == false) {
                                return "No";
                            } else {
                                return "";
                            }
                        },
                    },
                ],
                items: [],
                selected: [],
            },

        };
    },
    watch: {
        surname: {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.passenger = newVal + "/"
                    if (this.firstname) {
                        this.passenger += this.firstname
                    }
                }
            },
        },
        firstname: {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    if (this.surname) {
                        this.passenger = this.surname + "/"
                    }
                    this.passenger += newVal
                }
            },
        },
    },
    methods: {
        async accessdenied() {

        },
        async load() {
            this.ticketno = []
            // if (this.selection.length > 0) {
            //     this.surname = this.selection[0].surname
            //     this.firstname = this.selection[0].firstname
            //     this.title = this.selection[0].title
            //     this.passenger = this.selection[0].passenger
            //     this.eventcode = this.selection[0].eventcode
            //     this.slac = this.selection[0].slac
            //      this.blac = this.selection[0].blac
            //     this.yourref = this.selection[0].yourref
            // }

            for (var i = 0; i < this.selection.length; ++i) {
                this.ticketno.push(this.selection[i].ticketno)
            }

            await this.voids_load();
            await this.zhold_load();
        },
        async reasontype_change(v) {
            console.log('reasontype_change', v)
        },
        async voids_load(offset, limit, page) {

            this.voids.items = []
            for (var i = 0; i < this.selection.length; ++i) {
                if (this.selection[i].ticketno.slice(0, 2) == 'CH' && !this.selection[i].invoiceno) {
                    this.voids.items.push(this.selection[i])
                }
            }

        },
        async voids_select(ss, tools) {
            console.log("voids_select", ss);
        },
        async voids_click(a, ss) {
            console.log("voids_click", a, ss);
        },

        async zhold_load(offset, limit, page) {
            this.zhold.items = []
            for (var i = 0; i < this.selection.length; ++i) {
                this.zhold.items.push(this.selection[i])
            }
        },

        async zhold_click(a, ss) {
            console.log("zhold_click", a, ss);

            let state = this.zhold;

            switch (a) {

                case "go":
                    this.component = null;
                    await this.zhold_load();
                    break;

            }
        },
        async zhold_select(ss, tools) {
            console.log("zhold_select", ss);

            let state = this.zhold;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "go", "filter", "add", "export"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "notes"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["save", "deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }

            if (state.selected.length > 0) {
                state.item = state.selected[0]  // WHAT YOU SELECTED

                // state.item.datetravel = this.$moment.unix(state.item.datetravel * 0.001).utc(true).format("YYYY-MM-DD")
                // state.item.dateref = this.$moment.unix(state.item.dateref * 0.001).utc(true).format("YYYY-MM-DD")
                // state.item.datedepart = this.$moment.unix(state.item.datedepart * 0.001).utc(true).format("YYYY-MM-DD")

            } else {
                state.item = {}
            }
        },
        async timestamp() {
            if (!this.notes) { this.notes = "" }
            this.notes +=
                this.$moment().format("DD/MM/YY HH:mm") +
                " " +
                this.user.initials +
                "\n";
        },

        async saveit() {
            this.busy = true;

            let variables = {}
            let rows = []

            let operation = this.reasontype[this.tabindex - 1]

            switch (operation) {
                case "void":
                    for (var j = 0; j < this.voids.items.length; j++) {
                        let item = this.voids.items[j]
                        let row = {
                            id: item.id,
                        }
                        switch (this.void_type) {
                            case "void":
                                row.type = "VOID"
                                break;
                            case "charter":
                                row.type = "CHARTER"
                                break;
                            case "toggle":
                                switch (item.type.toUpperCase()) {
                                    case "VOID":
                                        row.type = "CHARTER"
                                        break;
                                    case "CHARTER":
                                        row.type = "VOID"
                                        break;
                                }
                                break;
                        }

                        rows.push(row);
                    }
                    variables.rows = rows
                    break;

                case "client":
                    for (var j = 0; j < this.selection.length; j++) {
                        let row = {
                            id: this.selection[j].id,
                            yourref: this.yourref,
                            slac: this.slac,
                            blac: this.blac,
                            eventcode: this.eventcode,
                            invoiceno: this.invoiceno,
                        }
                        rows.push(row);
                    }
                    variables.rows = rows
                    break;

                case "namechange":
                    for (var j = 0; j < this.selection.length; j++) {
                        let row = {
                            id: this.selection[j].id,
                            surname: this.surname,
                            firstname: this.firstname,
                            title: this.title,
                            passenger: this.passenger
                        }
                        rows.push(row);
                    }
                    variables.rows = rows
                    break;

                case "notes":
                    for (var j = 0; j < this.selection.length; j++) {
                        let row = {
                            id: this.selection[j].id,
                            notes: this.notes
                        }
                        rows.push(row);
                    }
                    variables.rows = rows
                    break;

            }

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                                mutation tickets_save($rows: [Ticket_input]) {
                                tickets_save(rows: $rows) {
                                    id
                                    surname
                                    firstname
                                    title
                                    passenger
                                    notes
                                }
                                }
                            `,
                    variables,
                });
                this.message = "<span class='text-primary'>Saved it.</span>";

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },

    },
};
</script>